import { t } from "i18next";
import { Navigate, Outlet } from "react-router";
import { toast } from "react-toastify";
import { useRefreshCurrentUser } from "../../hooks/useRefreshCurrentUser";
import {
  selectImpersonating,
  selectUser,
  selectUserToken,
} from "../../store/slices/auth";
import { useSelector } from "../../store/store";

export const ProtectedRoute = () => {
  const userToken = useSelector(selectUserToken);
  const user = useSelector(selectUser);
  const isAuthenticated = user && userToken;
  const isConfirmed = user?.is_confirmed;
  const impersonating = useSelector(selectImpersonating);
  useRefreshCurrentUser();

  if (!isAuthenticated) {
    toast.error(t("errors.unauthorized"));
    return <Navigate to="/login" />;
  }

  // An admin impersonating an unconfirmed account must still see its space
  if (!isConfirmed && !impersonating) {
    toast.error(t("errors.emailNotConfirmed"));
    return <Navigate to="/confirm-email" />;
  }

  return <Outlet />;
};
